import React, { memo } from 'react'
import { Grid } from '@mui/material'

import FAQs from './FAQs'
import RecentDeposits from './RecentDeposits'
import Partners from './Partners'
import SaleRunning from './SaleRunning'
import SaleResults from './SaleResults'

const CommunitySale = ({
  t,
  mainProfile,
  saleRunningProps,
  saleResultsProps,
  isWalletConnected,
  saleEnded,
  showResults,
  dispatchAction
}) => {
  return (
    <Grid container spacing={3} pt={2}>
      <Grid item xs={12}>
        {showResults ? (
          <SaleResults
            t={t}
            mainProfile={mainProfile}
            isWalletConnected={isWalletConnected}
            dispatchAction={dispatchAction}
            {...saleResultsProps}
          />
        ) : (
          <SaleRunning
            t={t}
            mainProfile={mainProfile}
            isWalletConnected={isWalletConnected}
            saleEnded={saleEnded}
            {...saleRunningProps}
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <RecentDeposits t={t} timeline={mainProfile.timeline} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <FAQs t={t} mainProfile={mainProfile} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Partners t={t} />
      </Grid>
    </Grid>
  )
}

export default memo(CommunitySale)
